import GxFilterDropdown from "@/app/components/common/actions/dropdowns/GxFilterDropdown";
import { ICON_BASE_PATH } from "@/app/utils/config";
import { useState } from "react";
import type { StatusOption } from "../../beneficiaries/Beneficiaryconstants";
import { t } from "i18next";
import SearchInput from "@/app/components/common/actions/inputs-b/SearchInput";
import { MatchedExample } from "./MatchedExample";

export const Matched = () => {
  const [isDrawerOpenAdvancedFilter, setIsDrawerOpenAdvancedFilter] =
    useState(false);

  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([
    { value: "All", label: t("all") },
  ]);

  const [isAdvancedFilterActive, setIsAdvancedFilterActive] = useState(false);
  const [rows, setRows] = useState<any[]>([]);
  const [filters, setFilters] = useState({
    status: "",
    requestFrom: "",
    search: "",
  });

  const requestFromOptions = [
    { value: "All", label: t("all") },
    { value: "Existing Payer", label: t("existing_payer") },
    { value: "Ad Hoc Payer", label: t("ad_hoc") },
  ];

  const handleSearchChange = (value: string) => {
    setIsAdvancedFilterActive(false);
    setFilters((p) => ({ ...p, search: value }));
  };

  const handleStatusChange = (value: string | null) => {
    if (value) {
      setIsAdvancedFilterActive(false);
      setFilters((p) => ({ ...p, status: value === "All" ? "" : value }));
    }
  };

  const handleRequestFromChange = (value: string | null) => {
    if (value) {
      setIsAdvancedFilterActive(false);
      setFilters((p) => ({ ...p, requestFrom: value === "All" ? "" : value }));
    }
  };

  return (
    <div>
      <div className="grid grid-cols-5 gap-4">
        <div className="gx-total-card">
          <div className="gx-img-background blue">
            <img src={`${ICON_BASE_PATH}totaltransactions.svg`} alt="" />
          </div>
          <div className="gx-title-count">
            <h3>
              Total Transactions
              <img
                src={`${ICON_BASE_PATH}info-icon-black.svg`}
                className="info-icon"
                alt=""
              />{" "}
              <span>1,530</span>
            </h3>
            <p>97.44% of total</p>
          </div>
        </div>
        <div className="gx-total-card">
          <div className="gx-img-background green">
            <img src={`${ICON_BASE_PATH}automatched.svg`} alt="" />
          </div>
          <div className="gx-title-count">
            <h3>
              Auto-Matched{" "}
              <img
                src={`${ICON_BASE_PATH}info-icon-black.svg`}
                className="info-icon"
                alt=""
              />{" "}
              <span>1,530</span>
            </h3>
            <p>97.44% of total</p>
          </div>
        </div>
        <div className="gx-total-card">
          <div className="gx-img-background orange">
            <img src={`${ICON_BASE_PATH}partialmatched.svg`} alt="" />
          </div>
          <div className="gx-title-count">
            <h3>
              Partial Matched
              <img
                src={`${ICON_BASE_PATH}info-icon-black.svg`}
                className="info-icon"
                alt=""
              />{" "}
              <span>1,530</span>
            </h3>
            <p>97.44% of total</p>
          </div>
        </div>
        <div className="gx-total-card">
          <div className="gx-img-background red">
            <img src={`${ICON_BASE_PATH}unmatched.svg`} alt="" />
          </div>
          <div className="gx-title-count">
            <h3>
              Unmatched
              <img
                src={`${ICON_BASE_PATH}info-icon-black.svg`}
                className="info-icon"
                alt=""
              />{" "}
              <span>1,530</span>
            </h3>
            <p>97.44% of total</p>
          </div>
        </div>
        <div className="gx-total-card">
          <div className="gx-img-background purple">
            <img src={`${ICON_BASE_PATH}matchrate.svg`} alt="" />
          </div>
          <div className="gx-title-count">
            <h3>
              Match Rate
              <img
                src={`${ICON_BASE_PATH}info-icon-black.svg`}
                className="info-icon"
                alt=""
              />{" "}
              <span>1,530</span>
            </h3>
            <p>97.44% of total</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 mt-5">
        <div className="gx-fitter-row">
          <div>
            <button onClick={() => setIsDrawerOpenAdvancedFilter(true)}>
              <img
                src={`${ICON_BASE_PATH}filter.svg`}
                alt="filter"
                className="filter-icon"
              />
            </button>
          </div>
          <div>
            <GxFilterDropdown
              data={statusOptions}
              value={filters.status}
              onChange={handleStatusChange}
              label={"Status"}
            />
          </div>
          <div>
            <GxFilterDropdown
              data={requestFromOptions}
              value={filters.requestFrom}
              onChange={handleRequestFromChange}
              label={"Document Type"}
            />
          </div>
          <div>
            <GxFilterDropdown
              data={requestFromOptions}
              value={filters.requestFrom}
              onChange={handleRequestFromChange}
              label={"Received From"}
            />
          </div>
        </div>
        <div className="gx-search-container">
          <SearchInput
            searchQuery={filters.search}
            placeholder={
              "Search by bank narrative, reference tokens, AI suggestion references"
            }
            onSearchChange={handleSearchChange}
          />
        </div>
      </div>
      <div className="grid grid-cols-12 mt-5">
        <div className="col-span-12">
          <div className="gx-border-bottom-line w-full"></div>
        </div>
      </div>
      <div className="grid grid-cols-12 mt-5">
        <div className="col-span-12">
          <MatchedExample />
        </div>
      </div>
    </div>
  );
};
